import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";

const Socialmediapopup = ({ buttonName, onClick, closePopup }) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const data = {
          platform: e.target.name.value,
          userId: e.target.userId.value,
          url: e.target.link.value,
        };
        onClick(data);
      }}
      className="fixed inset-0 z-50 w-screen h-screen bg-black/50 backdrop-blur-sm flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md mx-4 bg-white rounded-xl shadow-lg"
      >
        {/* Close button */}
        <button
          onClick={() => closePopup()}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <IoIosCloseCircleOutline size={24} />
        </button>

        {/* Content */}
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">
            Add Social Media Account
          </h2>

          <div className="space-y-4">
            {/* Name Input */}
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Platform Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                placeholder="e.g., Instagram"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
              />
            </div>

            {/* User ID Input */}
            <div>
              <label
                htmlFor="userId"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                User ID
              </label>
              <input
                id="userId"
                name="userId"
                type="text"
                required
                placeholder="e.g., username@email.com"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
              />
            </div>

            {/* Account Link Input */}
            <div>
              <label
                htmlFor="link"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Profile Link
              </label>
              <input
                id="link"
                name="link"
                type="url"
                placeholder="https://instagram.com/username"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent transition-all"
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full mt-6 bg-[#FF6B00] hover:bg-[#FF6B00]/90 text-white font-medium py-2.5 px-4 rounded-lg transition-colors"
          >
            {buttonName}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Socialmediapopup;
